import { useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import Button from "../../../components/form-controls/Button";
import useModal from "../../../hooks/useModal";
import { useForm } from "react-hook-form";
import Input from "../../../components/form-controls/Input";
import { AlertService } from "../../../services/Alert";
import { MetaService } from "../../../services/MetaService";


interface SetMediaModalProps {
    state: { show: boolean, template: any };
    onRequestClose: (refresh: boolean) => void;
}

function SetMediaModal({ state, onRequestClose }: SetMediaModalProps) {

    const modal = useRef<HTMLDivElement>(null);

    useModal(modal, state.show)

    const defaultValues = {
        file: '',
    }

    const {register, handleSubmit, setValue, reset, formState: { errors, isValid, isSubmitting }} = useForm({
        mode: 'onChange',
        defaultValues
    });

    const header = useMemo(() => {
        if(!state.template) return null;
        
        const template = JSON.parse(state.template.body);
        return template.find( t => t.type === 'HEADER')

    }, [state.template])

    const uploadFile = async({ target: { files }}) => {
        
        const bytesToMegabytes = (bytes) => {
            const megabytes = bytes / (1024 * 1024);
            return megabytes.toFixed(2);
        }

        const file = files[0];
        const sizeMB = +bytesToMegabytes(file.size);
        const type = header.format

        if(sizeMB > 5) {
            AlertService.toastError('Sólo se permiten archivos de máximo 5MB')
            setValue('file', '')
            return;
        }

        if(type === 'IMAGE' && (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png')) {
            AlertService.toastError('Sólo se permiten imagenes en formato png o jpg')
            setValue('file', '')
            return;
        }
        if(type === 'VIDEO' && file.type !== 'video/mp4' ) {
            AlertService.toastError('Sólo se permiten videos en formato mp4')
            setValue('file', '')
            return;
        }
        if(type === 'DOCUMENT' && file.type !== 'application/pdf' ) {
            AlertService.toastError('Sólo se permiten archivos en formato PDF')
            setValue('file', '')
            return;
        }

    }
    

    const submit = async(payload) => {
        try {
            const form = new FormData()
            form.append('file', payload.file[0])
            form.append('template_id', state.template.id)

            await MetaService.setMedia(form)

            await onRequestClose(true)

            AlertService.toastSuccess('Se guardó correctamente el contenido media.')
            
            reset(defaultValues)
            
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!', 'No se pudo modificar el contenido media de la plantilla, intenta más tarde.')
        }
    }

    return (
        <div className="modal fade" ref={modal} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content ">
                    <div className="modal-header">
                        <h4 className="modal-title">Editar media</h4>
                        <button type="button" className="btn-close" onClick={() => onRequestClose(false)}></button>
                    </div>
                    <div className="modal-body">
                        
                        <div className="row">
                                <div className="col">
                                    <div className="" >
                                        <h5>Contenido del encabezado</h5>
                                        <p>Incluye el archivo que se enviará al cliente cada vez que utilices esta plantilla. Solo se aceptan archivos menores a 5MB</p>
                                        <h6>
                                            { header && header.format === 'IMAGE' && 'Para esta plantilla, sólo se aceptan archivos en formato png o jpg'}
                                            { header && header.format === 'VIDEO' && 'Para esta plantilla, sólo se aceptan archivos en formato mp4'}
                                            { header && header.format === 'DOCUMENT' && 'Para esta plantilla, sólo se aceptan archivos en formato PDF'}
                                        </h6>
                                        <div>
                                            <Input
                                                label={'Archivo'}
                                                type='file'
                                                errors={errors.file} 
                                                {...register('file', { required: true, onChange: uploadFile })}
                                                sizeClass='form-control-sm'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-white btn-sm" onClick={() => onRequestClose(false)}>Cancelar</button>
                        <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>Guardar</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SetMediaModal